<template>
    <v-card elevation="0">
        
        <v-card-text v-if="loading" class="text-center justify-center" min-height="300">
        <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
            ></v-progress-circular>
        </v-card-text>
        <v-card-text v-if="resources">
            <v-card v-for="r in resources.data" v-if="r" :key="r.id + 'resource'">
                <v-container>
                <v-row>
                    <v-col cols="12" lg="4" md="4">
                        <v-card elevation="10">
                            <v-card-title><v-icon>mdi-file</v-icon> {{ r.name }}</v-card-title>
                            <v-card-text>
                                    <p v-html="r.description"></p>
                                    <a 
                                        :href="baseurl + '/downloadables/'+r.path" target="_blank">
                                        <v-btn color="primary">
                                            <v-icon
                                                small
                                                class="mr-2"
                                                
                                            >
                                                mdi-download
                                            </v-icon>
                                             View
                                        </v-btn>
                                    </a>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            </v-card>
            <Pagination :isJSON="true" v-if="resources && resources.links" :links="resources.links" @pageClick="pageClicked($event)"></Pagination>
        </v-card-text>
        <v-card-text class="border-top-purple" v-if="event_resources">
            <v-container>
                <v-row>
                    <v-col cols="12" lg="4" md="4" v-for="r in event_resources.data" :key="r.id + 'event'">
                        <v-card elevation="10">
                            <v-card-title><v-icon>mdi-calendar</v-icon> {{ r.title }}</v-card-title>
                            <v-card-text>
                                <v-data-table
                                    :headers="headers"
                                    :items="r.downloads"
                                    class="elevation-1"
                                    :hide-default-header="true"
                                    :hide-default-footer="true"
                                >
                                <template v-slot:item.name="{ item }">
                                    {{ item.name }}
                                    </template>
                                <template v-slot:item.download="{ item }">
                                    <a 
                                        :href="baseurl + '/downloadables/'+item.path" target="_blank">
                                    <v-icon
                                        small
                                        class="mr-2"
                                        
                                    >
                                        mdi-download
                                    </v-icon>
                                    </a>
                                    
                                </template>
                                
                                </v-data-table>
                            </v-card-text>
                        </v-card>

                    </v-col>
                </v-row>
            </v-container>
            <Pagination :isJSON="true" v-if="event_resources && event_resources.links" :links="event_resources.links" @pageClick="eventpageClicked($event)"></Pagination>
        </v-card-text>
    </v-card>
</template>

<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import axios from 'axios'
  import Pagination from '@/Shared/Pagination'


  export default {
    props: {
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
    },
    components: {
      Pagination
    },
    layout: Layout,
    data() {
        return {
            applyDialog: false,
            expandSearch: false,
            loading:false,
            resources:null,
            event_resources:null,
            currentEventPage:null,
            currentPage:1,
            headers: [
                { text: 'Name', value:'name'},
                { text: 'Download', value:'download'},
            ]
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.getResources({});
        this.getEventResources({});
    },
    methods: {
        getResources(data) {
            this.loading=true;
            var vm=this;
            if (!data || !data.label)
                data.resource_page = 1;
            else if (data.label == 'Next &raquo;')
                data.resource_page = this.currentPage+1;
            else if (parseInt(data.label))
                data.resource_page = data.label;
            else
                data.resource_page = this.currentPage-1;

            axios.get(this.baseurl+'/user/resources',{ params:data }).then(function (result){
                console.log('got resources',result)
                vm.resources = result.data;
                
                vm.currentPage = data.resource_page;
                vm.loading=false;
            })
            .catch(function (e) { console.log('error',e)}) 
        },
        getEventResources(data) {
            this.loading=true;
            var vm=this;
            if (!data || !data.label)
                data.event_resource_page = 1;
            else if (data.label == 'Next &raquo;')
                data.event_resource_page = this.currentEventPage+1;
            else if (parseInt(data.label))
                data.event_resource_page = data.label;
            else
                data.event_resource_page = this.currentEventPage-1;

            axios.get(this.baseurl+'/user/eventresources',{ params:data }).then(function (result){
                console.log('got event resources',result)
                vm.event_resources = result.data;
                
                vm.currentEventPage = data.event_resource_page;
                vm.loading=false;
            })
            .catch(function (e) { console.log('error',e)}) 
        },
        pageClicked(e) {
            console.log('page clicked',e)
            this.getResources(e);
        },
        eventpageClicked(e) {
            console.log('page clicked',e)
            this.getEventResources(e);
        },
        toggleComponentLogin(e) {
            console.log('results triggering login',e)
            if (!this.auth.user)
                this.$parent.$emit('toggleComponentLogin',e);
        
        },
    },
  }
  </script>